import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from 'react';
import { useTranslation } from 'react-i18next';
var AlertComponent = lazy(function () { return import('../../UIcomponents/AlertComponent/AlertComponent'); });
var OrderSubscription = function () {
    var t = useTranslation('settings').t;
    return _jsx(AlertComponent, { type: "error", message: t('subscription.alert.notSubscribed') });
};
export default OrderSubscription;
